import { roles } from '../../configs/permissionsConfig'
import useCrud from '../useCrud'

const useUser = () => {
  const { get: getAll } = useCrud('/admin/v1/users/all')

  const getCollaborator = ({ institutionId, ...params }) => {
    return getAll(
      ['users', 'collaborator', 'all', institutionId],
      { role: roles.collaborator, institution_id: institutionId, ...params },
      { enabled: Boolean(institutionId) }
    )
  }

  return { getCollaborator }
}

export default useUser
